import { useState, useCallback } from 'react';

export const useLeadCapture = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<string>('');
  const [selectedProductImage, setSelectedProductImage] = useState<string>('');

  const openModal = useCallback((productName?: string, productImage?: string) => {
    setSelectedProduct(productName || '');
    setSelectedProductImage(productImage || '');
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProduct('');
    setSelectedProductImage('');
  }, []);

  return {
    isModalOpen,
    selectedProduct,
    selectedProductImage,
    openModal,
    closeModal
  };
};